import { Field, ID, ObjectType } from 'type-graphql'
import GraphQLJSON from 'graphql-type-json'
import type { CompareDataKindEnum } from './CompareDataKindEnum'

@ObjectType()
export class CompareData {
  @Field(() => ID)
  _id: string

  @Field(() => String)
  code?: string

  @Field(() => GraphQLJSON)
  diffValues?: any[]

  @Field(() => Boolean)
  isNew?: boolean

  @Field(() => String)
  kind: CompareDataKindEnum
}
